const JAPAN_TIMEZONES = new Set(['Asia/Tokyo']);
const LOCALE_STORAGE_KEY = 'chordanalyzer.locale';
const SUPPORTED_LOCALES = new Set(['ja', 'en']);
const LOCALE_EVENT_NAME = 'chordanalyzer:localechange';

export function detectLocaleByTimeZone() {
  try {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (JAPAN_TIMEZONES.has(timeZone)) {
      return 'ja';
    }
  } catch (error) {
    console.warn('Locale detection by timezone failed:', error);
  }
  return 'en';
}

export function getLocalePreference() {
  try {
    const stored = window.localStorage.getItem(LOCALE_STORAGE_KEY);
    if (stored && SUPPORTED_LOCALES.has(stored)) {
      return stored;
    }
  } catch (error) {
    console.warn('Failed to read locale preference:', error);
  }
  return detectLocaleByTimeZone();
}

export function setLocalePreference(locale) {
  if (!SUPPORTED_LOCALES.has(locale)) return;
  try {
    window.localStorage.setItem(LOCALE_STORAGE_KEY, locale);
    window.dispatchEvent(new CustomEvent(LOCALE_EVENT_NAME, { detail: { locale } }));
  } catch (error) {
    console.warn('Failed to persist locale preference:', error);
  }
}

export function subscribeLocaleChange(handler) {
  if (typeof handler !== 'function') return () => {};
  const onLocaleChange = (event) => {
    const locale = event?.detail?.locale;
    if (locale && SUPPORTED_LOCALES.has(locale)) {
      handler(locale);
      return;
    }
    handler(getLocalePreference());
  };
  const onStorage = (event) => {
    if (event.key === LOCALE_STORAGE_KEY) {
      handler(getLocalePreference());
    }
  };
  window.addEventListener(LOCALE_EVENT_NAME, onLocaleChange);
  window.addEventListener('storage', onStorage);
  return () => {
    window.removeEventListener(LOCALE_EVENT_NAME, onLocaleChange);
    window.removeEventListener('storage', onStorage);
  };
}
